import { render, staticRenderFns } from "./bill-address-form.vue?vue&type=template&id=64a31573"
import script from "./bill-address-form.vue?vue&type=script&lang=js"
export * from "./bill-address-form.vue?vue&type=script&lang=js"
import style0 from "./bill-address-form.vue?vue&type=style&index=0&id=64a31573&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports